import dcapital from './dcapital.ru';
export default {
  nav: { home: 'Главная', selection: 'Отбор трейдеров', training: 'Обучение', apply: 'Оставить заявку', signin: 'Войти' },
  ticker: ['AAPL +1.24%', 'TSLA -0.87%', 'NVDA +2.41%', 'MSFT +0.66%', 'NASDAQ 18 412.55', 'NYSE 19 204.11', 'AMZN +1.02%', 'META -0.43%', 'GOOGL +0.95%', 'AMD +3.12%'],
  common: { result: 'Результат', popular: 'Популярный', soldOut: 'Распродано', waitlistBtn: 'В лист ожидания', soldOutHint: 'Мест нет. Оставьте заявку, чтобы попасть в лист ожидания.', choose: 'Выбрать формат', start: 'Старт', orPaypal: 'или оплатите через' },
  home: {
    heroOverline: 'Профессиональная торговая платформа · NYSE & NASDAQ',
    heroLines: ['Торгуй на', 'американском', 'рынке акций'],
    heroSub: 'Проп-команда ALEF. Обучаем трейдеров с нуля и отбираем лучших в команду — квалифицируйся один раз и получай капитал в управление до $1 000 000.',
    ctaPrimary: 'Пройти отбор',
    ctaSecondary: 'Программа обучения',
    stats: [
      { v: '$1M', l: 'Максимальный капитал', s: 'Растёт по мере стабильности' },
      { v: '12 нед.', l: 'Программа обучения', s: 'Пошаговый путь NYSE & NASDAQ' },
      { v: '1×', l: 'Одна квалификация', s: 'Счёт увеличивается автоматически' },
    ],
    pillarsOverline: 'Три направления',
    pillarsTitle: 'Выбери свой путь в трейдинге',
    pillars: [
      { num: '01', title: 'Отбор трейдеров', desc: 'Уже торгуешь? Продемонстрируй стабильность на демо-этапе и получи реальный счёт с масштабированием капитала до $1M.', cta: 'Подать заявку на отбор' },
      { num: '02', title: 'Обучение с нуля', desc: 'Трёхмесячная программа: от устройства рынка до собственной торговой системы — с живыми занятиями и сопровождением наставника.', cta: 'Смотреть программу' },
      { num: '03', title: 'Карьера в команде', desc: 'Лучшие выпускники и трейдеры, прошедшие отбор, торгуют капиталом компании, растут в доле прибыли и становятся наставниками.', cta: 'Начать путь' },
    ],
    whyOverline: 'Рынок',
    whyTitle: 'Почему NYSE & NASDAQ?',
    whyItems: [
      'Крупнейшие и самые ликвидные биржи мира',
      'Apple, Microsoft, Google, Tesla и тысячи других компаний',
      'Капитализация рынка — более $50 трлн',
      'Торговые возможности каждый день, 9:30–16:00 EST',
      'Профессиональные инструменты и данные в реальном времени',
    ],
    benOverline: 'Преимущества',
    benTitle: 'Почему ALEF TRADERS',
    benefits: [
      { t: 'Капитал под результат', d: 'Доступ к серьёзному торговому капиталу — в зависимости от твоей стабильности и риск-менеджмента.' },
      { t: 'Профессиональная поддержка', d: 'Выделенная команда поддержки, продвинутые инструменты и инфраструктура институционального уровня.' },
      { t: 'Гибкое распределение прибыли', d: 'Конкурентная модель profit split, которая вознаграждает стабильность и дисциплину.' },
      { t: 'Карьерный рост', d: 'Возможности развития, менторство и профессиональный рост внутри команды.' },
    ],
    aboutOverline: 'О компании',
    aboutName: 'ALEF TRADERS',
    aboutRole: 'Профессиональная команда трейдеров · NYSE & NASDAQ',
    aboutBio: 'ALEF Traders — команда профессиональных трейдеров американского фондового рынка. Мы на рынке с 2012 года, а на профессиональной основе работаем с 2017. За это время команда управляла фондом свыше $10 000 000 и заработала более $3 000 000. Сегодня мы развиваем собственную проп-команду: обучаем трейдеров с нуля и предлагаем лучшим ученикам и кандидатам, прошедшим отбор, торговать капиталом компании.',
    aboutStats: [
      { v: '2012', l: 'На рынке с' },
      { v: '$10M+', l: 'Под управлением' },
      { v: '$3M+', l: 'Прибыль команды' },
    ],
    ctaTitle: 'Готов начать карьеру трейдера?',
    ctaSub: 'Начинаешь с нуля или приходишь с опытом — у нас есть подходящий путь для тебя.',
    ctaBtn: 'Оставить заявку',
  },
  selection: {
    overline: 'Для опытных трейдеров',
    heroLines: ['Покажи навык.', 'Получи капитал', 'до $1 000 000'],
    heroSub: 'Никаких собеседований и дипломов — только твоя торговля. Пройди отбор на демо-счёте и торгуй капиталом компании на NYSE & NASDAQ.',
    ctaBtn: 'Подать заявку на отбор',
    metrics: [
      { v: '$1M', l: 'Максимальный капитал' },
      { v: '30–50%', l: 'Доля от прибыли' },
      { v: '2', l: 'Этапа отбора' },
      { v: '9:30–16:00', l: 'Сессия EST' },
    ],
    stepsOverline: 'Процесс',
    stepsTitle: 'Как устроен отбор',
    steps: [
      { num: '01', t: 'Заявка', d: 'Заполни короткую форму — расскажи о своём опыте и рынках, на которых торгуешь.' },
      { num: '02', t: 'Демо-этап', d: 'Торгуй на демо-счёте по правилам риск-менеджмента. Покажи стабильность и достигни цели по прибыли.' },
      { num: '03', t: 'Верификация', d: 'Подтверди результат на втором этапе с более мягкими целями — мы проверяем системность, а не удачу.' },
      { num: '04', t: 'Реальный счёт', d: 'Получи капитал в управление. За стабильную торговлю счёт масштабируется — вплоть до $1 000 000.' },
    ],
    condOverline: 'Условия',
    condTitle: 'Правила игры',
    conditions: [
      'Рынки: акции NYSE & NASDAQ',
      'Дневной лимит убытка и общий лимит просадки',
      'Цель по прибыли на каждом этапе без нарушения рисков',
      'Масштабирование счёта за стабильную торговлю',
      'Регулярные выплаты прибыли по расписанию',
    ],
    benOverline: 'Почему мы',
    benTitle: 'Что получает трейдер команды',
    priceOverline: 'Стоимость участия',
    priceTitle: 'Отбор трейдеров — два формата участия',
    plans: [
      {
        key: 'online', name: 'Онлайн', price: '$999', note: 'Единоразовый платёж: мини-курс + участие в отборе',
        features: ['Мини-курс по трейдингу — доступ онлайн в записи', 'Доступ к демо-этапу отбора', 'Проверка результатов и обратная связь от команды', 'При успехе — реальный счёт с капиталом компании', 'Масштабирование капитала до $1 000 000'],
        fit: 'Проходите отбор из любой точки мира в удобном ритме.',
      },
      {
        key: 'office', name: 'В офисе', price: '$1 499', note: 'Единоразовый платёж: всё из онлайн-формата + работа в офисе', badge: true,
        features: ['Всё из онлайн-формата', 'Оборудованное рабочее место в офисе на весь период отбора', 'Торговля рядом с командой в реальном времени', 'Живые разборы сделок и ежедневный контакт с наставниками', 'Погружение в рабочую среду профессиональных трейдеров', 'Приоритетное рассмотрение результатов'],
        fit: 'Для тех, кто хочет максимально быстро влиться в команду и торговать плечом к плечу с профессионалами.',
      },
    ],
    priceBtn: 'Оплатить и пройти отбор',
    payMethods: 'Оплата картой (Stripe), PayPal или USDT (TRC20) — сразу после короткой заявки',
    ctaTitle: 'Готов пройти отбор?',
    ctaSub: 'Оставь заявку — команда свяжется с тобой в Telegram в течение рабочего дня.',
  },
  training: {
    badge: 'Старт потока · 18 января 2027 · набор открыт',
    heroLines: ['Профессиональное', 'обучение', 'трейдингу'],
    heroSub: 'От первых шагов на рынке до самостоятельной торговли под сопровождением наставника.',
    ctaPrimary: 'Записаться на консультацию',
    ctaSecondary: 'Посмотреть форматы',
    countdownTitle: 'До старта потока:',
    countdownUnits: { d: 'дней', h: 'часов', m: 'минут', s: 'секунд' },
    stats: [
      { v: '3 мес.', l: 'Длительность' },
      { v: 'Live', l: 'Онлайн-занятия' },
      { v: 'Реальный', l: 'Рынок' },
      { v: 'Mentor', l: 'Сопровождение' },
    ],
    approachOverline: 'Наш подход',
    approachQuote: '«Мы обучаем профессии трейдера, а не продаём мечту о быстром обогащении.»',
    approachText1: 'Большинство курсов ограничиваются набором видеоуроков «в записи» — теория без обратной связи, без контроля и без сопровождения.',
    approachText2: 'Наша программа построена иначе. Ученик проходит полный путь: новичок → практика → собственная торговая система → реальная торговля.',
    compOverline: 'Что входит в программу',
    compTitle: 'Шесть компонентов, которые делают результат предсказуемым',
    components: [
      { t: 'Теория', d: 'Фундаментальные знания о рынке, инструментах и стратегиях.' },
      { t: 'Практика', d: 'Реальные графики, разбор сделок, отработка навыков.' },
      { t: 'Обратная связь', d: 'Индивидуальный разбор ваших ошибок и решений.' },
      { t: 'Наставничество', d: 'Прямой контакт с действующим трейдером.' },
      { t: 'Сообщество', d: 'Закрытый чат с менторами и выпускниками.' },
      { t: 'Сопровождение', d: 'Поддержка при переходе на реальный счёт.' },
    ],
    princOverline: 'Почему программа работает',
    princTitle: 'Восемь принципов, отличающих нас от записанных курсов',
    principles: [
      'Живые занятия в режиме реального времени',
      'Возможность задавать вопросы во время обучения',
      'Записи всех занятий — доступ навсегда',
      'Закрытое сообщество практикующих трейдеров',
      'Разбор реальных рыночных ситуаций',
      'Индивидуальная обратная связь по сделкам',
      'Подготовка собственной торговой системы',
      'Сопровождение до выхода на реальный рынок',
    ],
    roadOverline: 'Дорожная карта',
    roadTitle: 'Месяц 1 → Месяц 2 → Месяц 3',
    roadSub: 'Фундамент → Практика → Реальная торговля',
    months: [
      {
        num: '01', meta: '4 недели · 3 занятия в неделю · 1–1,5 часа', title: 'Фундамент трейдера',
        items: ['Знакомство с финансовыми рынками', 'Устройство трейдинга', 'Открытие торгового счёта', 'Настройка терминала', 'Работа с ордерами', 'Технический анализ', 'Тренды и уровни', 'Пробои и развороты', 'Торговые стратегии', 'Риск-менеджмент', 'Психология трейдинга'],
        result: 'Ученик понимает рынок и умеет самостоятельно анализировать графики.',
      },
      {
        num: '02', meta: '4 недели · 2 разбора в неделю + индивидуальная работа · до 2 часов', title: 'Практика и собственная торговая система',
        items: ['Практические занятия в эфире', 'Разбор рынка в реальном времени', 'Разбор сделок участников', 'Анализ ошибок', 'Дополнительная теория', 'Индивидуальная обратная связь', 'Формирование собственной системы', 'Создание торгового плана'],
        result: 'Ученик получает рабочую систему принятия решений и готовится к самостоятельной торговле.',
      },
      {
        num: '03', meta: '4 недели · сопровождение наставника, созвон 2 раза в неделю · 1–1,5 часа', title: 'Выход на реальную торговлю',
        items: ['Подготовка к реальной торговле', 'Контроль соблюдения риск-менеджмента', 'Разбор реальных сделок', 'Сопровождение наставника', 'Помощь в психологической адаптации'],
        result: 'Ученик начинает торговать самостоятельно под контролем наставника.',
      },
    ],
    formatOverline: 'Формат обучения',
    formatTitle: 'Живое обучение + архив записей',
    formatItems: [
      'Все занятия проходят онлайн через Zoom / Google Meet',
      'Длительность занятий — 1–1,5 часа, разборы сделок до 2 часов',
      'Прямой эфир — вопросы во время занятия',
      'Каждое занятие записывается',
      'Доступ к архиву сохраняется на весь срок обучения',
      'Возможность пересматривать материал в любое время',
    ],
    commOverline: 'Закрытое сообщество',
    commTitle: 'Чат, где торгуют, а не «мотивируют»',
    commItems: ['Наставники и практикующие трейдеры', 'Ученики текущего потока', 'Выпускники программы', 'Обсуждение рынка, разбор сделок, рекомендации'],
    resOverline: 'Что получает участник',
    resTitle: 'Девять конкретных результатов программы',
    results: ['Обучение с нуля', 'Живые занятия', 'Практика на рынке', 'Доступ к записям', 'Закрытый чат', 'Индивидуальная обратная связь', 'Собственная торговая система', 'Поддержка наставника', 'Подготовка к реальной торговле'],
    priceOverline: 'Форматы участия',
    priceTitle: 'Выберите интенсивность сопровождения',
    tiers: [
      {
        name: 'Групповой формат', price: '$2 599', size: 'До 20 участников', start: 'Старт 18.01.2027', startDate: '2027-01-18T09:00:00-05:00',
        features: ['Полный 3-месячный курс', 'Все живые занятия', 'Доступ к записям на время курса', 'Закрытый чат', 'Базовая обратная связь'],
        fit: 'Для тех, кто хочет получить полноценное обучение по максимально доступной стоимости.',
      },
      {
        name: 'Малая группа', price: '$3 599', size: 'До 10 участников', start: 'Старт 18.01.2027', startDate: '2027-01-18T09:00:00-05:00', badge: true,
        features: ['Всё из группового формата', 'В 2 раза больше внимания наставника', 'Еженедельный разбор ваших личных сделок', 'Персональный торговый план', 'Приоритетные ответы в чате', 'Доступ к записям — ещё 3 месяца после курса'],
        fit: 'Для тех, кто хочет быстрее выйти на стабильный результат за счёт персонального внимания.',
      },
      {
        name: 'Индивидуально', price: '$9 999', size: '1 на 1', start: 'Старт в любое время',
        features: ['6 месяцев сопровождения: 3 месяца обучения + 3 месяца поддержки', 'Персональная программа', 'Индивидуальные созвоны', 'Полный разбор каждой сделки', 'Прямой контакт с наставником', 'Максимальное сопровождение'],
        fit: 'Для тех, кому нужен максимальный результат за минимальное время.',
      },
    ],
    aboutOverline: 'О компании',
    outOverline: 'Результаты после обучения',
    outTitle: 'К концу программы ученик умеет:',
    outcomes: ['Самостоятельно анализировать рынок', 'Определять точки входа', 'Управлять рисками', 'Работать по собственной системе', 'Контролировать эмоции', 'Вести торговый журнал', 'Торговать на реальном счёте по чёткому плану', 'Принимать решения как профессионал'],
    ctaTitle: 'Начни свой путь в трейдинге уже сегодня',
    ctaSub: 'Запишись на консультацию и узнай, какой формат обучения подойдёт именно тебе.',
    ctaBtn: 'Оставить заявку',
    ctaNote: 'Ответим в течение рабочего дня · 9:00–21:00 NY',
  },
  masterclass: {
    badge: 'Старт 23 сентября',
    urgency: 'Осталось всего 3 места!',
    heroLines: ['3-дневный', 'мастер-класс', 'по трейдингу'],
    heroSub: '3 видеоурока по 15–30 минут + практические задания. Подходит как новичкам, так и опытным трейдерам.',
    priceNow: '$59', priceOld: '$590', discount: 'Скидка 90%',
    ctaBtn: 'Записаться на мастер-класс',
    bonus: 'Бонус после регистрации: как получить капитал в управление до $1 млн!',
    aboutOverline: 'Инструктор',
    aboutTitle: 'О мастер-классе и инструкторе',
    aboutText1: 'Приветствую! Я профессиональный трейдер с многолетним опытом работы на финансовых рынках. За свою карьеру я помог сотням людей освоить искусство трейдинга и начать зарабатывать на финансовых рынках.',
    aboutText2: 'Этот 3-дневный мастер-класс — результат моего практического опыта. Здесь только проверенные стратегии и реальные техники, которые работают как для новичков, так и для опытных трейдеров.',
    forOverline: 'Аудитория',
    forTitle: 'Для кого этот мастер-класс',
    forCards: [
      { t: 'Для новичков', d: 'Вы научитесь основам трейдинга с нуля, поймёте, как работают рынки, и сделаете первые шаги под руководством опытного наставника.' },
      { t: 'Для опытных трейдеров', d: 'Усовершенствуйте навыки, изучите продвинутые стратегии управления рисками и научитесь стабильно увеличивать прибыль.' },
      { t: 'Для ищущих доп. доход', d: 'Трейдинг — возможность создать дополнительный источник дохода, уделяя рынкам всего 1–2 часа в день.' },
    ],
    getOverline: 'Содержание',
    getTitle: 'Что вы получите',
    getItems: [
      { t: '3 видеоурока', d: 'Ежедневные 15–30-минутные уроки с практическими заданиями.' },
      { t: 'Доп. материалы', d: 'Чек-листы, шаблоны и полезные ресурсы для обучения.' },
      { t: 'Поддержка', d: 'Доступ к Telegram-боту для получения материалов и поддержки.' },
      { t: 'Сообщество', d: 'Закрытое сообщество единомышленников-трейдеров.' },
    ],
    progOverline: 'Программа',
    progTitle: 'Программа мастер-класса',
    days: [
      { num: '1', label: 'День 1', t: 'Старт и стратегии входа', d: 'Какие рынки торговать и почему. Инструменты и рабочее пространство. Зоны спроса/предложения и триггеры входа. Частые ошибки новичков.' },
      { num: '2', label: 'День 2', t: 'Риск-менеджмент и дисциплина', d: 'Размер позиции. Стоп-лоссы и тейки. Сценарное планирование.' },
      { num: '3', label: 'День 3', t: 'Психология трейдинга', d: 'Контроль эмоций и работа с убытками. Дисциплина и торговый режим. Формирование мышления профессионального трейдера. Финальный чек-лист и переход к самостоятельной торговле.' },
    ],
    bonusOverline: 'Специальный бонус',
    bonusNote: 'для тех, кто пройдёт весь мастер-класс',
    bonusTitle: 'Как получить капитал в управление до $1 млн',
    bonusText: 'Эксклюзивный гайд о том, как пройти отбор в проп-трейдинговые компании и получить в управление капитал до 1 миллиона долларов для торговли.',
    achOverline: 'Итоги',
    achTitle: 'Чего вы достигнете',
    achieves: [
      { t: 'Стабильность', d: 'Научитесь торговать стабильно и уверенно.' },
      { t: 'Прибыль', d: 'Начнёте генерировать регулярный доход.' },
      { t: 'Навыки', d: 'Освоите профессиональные техники.' },
      { t: 'Уверенность', d: 'Обретёте уверенность в своих решениях.' },
    ],
    resOverline: 'Кейсы',
    resTitle: 'Реальные результаты',
    resText: 'Результаты учеников после прохождения мастер-класса и применения системы на практике.',
    cmpOverline: 'Сравнение',
    cmpTitle: 'Почему этот мастер-класс',
    usTitle: 'Этот мастер-класс',
    themTitle: 'Другие курсы',
    us: ['Проверенные стратегии от практика', 'Только актуальная информация 2026', 'Реальные кейсы и примеры', 'Практические задания каждый день', 'Доступ к Telegram-сообществу', 'Бонус: путь к $1 млн капитала'],
    them: ['Устаревшая теория из учебников', 'Общие фразы без конкретики', 'Нет практических примеров', 'Только видео без заданий', 'Нет поддержки и сообщества', 'Завышенная цена за базовую информацию'],
    faqOverline: 'FAQ',
    faqTitle: 'Частые вопросы',
    faqs: [
      { q: 'Я новичок, подойдёт ли мне этот мастер-класс?', a: 'Да. Программа построена от базы к практике: рынки, инструменты, точки входа, риск-менеджмент и психология. Опытные трейдеры закроют пробелы и систематизируют свой подход.' },
      { q: 'Нужен ли большой стартовый капитал?', a: 'Нет. Начать можно с небольшой суммы — главное система и дисциплина. А в бонусном гайде мы покажем, как получить в управление капитал до $1 млн.' },
      { q: 'Сколько времени нужно уделять трейдингу?', a: 'Во время мастер-класса — 15–30 минут на урок и 20–30 минут на задание каждый день. В дальнейшем достаточно 1–2 часов в день.' },
      { q: 'Как я получу доступ к материалам?', a: 'Сразу после оплаты: уроки и материалы приходят через Telegram-бот, а ссылка на закрытый чат — в подтверждении регистрации.' },
      { q: 'Есть ли гарантия возврата?', a: 'Да. Гарантия возврата средств — 48 часов с момента старта. Если поймёте, что формат не ваш, — вернём оплату без вопросов.' },
    ],
    finalTitle: 'Присоединяйтесь к мастер-классу прямо сейчас',
    timerTitle: 'До окончания акции осталось:',
    timerUnits: { h: 'часов', m: 'минут', s: 'секунд' },
    ctaBtn2: 'Записаться сейчас',
    ps: 'P.S. Вы ничем не рискуете! Гарантия возврата средств — 48 часов с момента старта.',
    stickyBtn: 'Присоединиться со скидкой 90%',
  },
  account: {
    prompt: 'Войдите, чтобы открыть личный кабинет',
    promptBtn: 'Войти через Google',
    sub: 'Вы вошли через Google-аккаунт',
    logout: 'Выйти',
    since: 'На платформе с',
  },
  pay: {
    title: 'Оплата обучения',
    sub: 'Заявка получена! Выберите формат и завершите оплату, чтобы забронировать место в потоке — старт 18 января 2027.',
    chooseLabel: 'Выберите формат',
    payBtn: 'Перейти к оплате',
    note: 'Безопасная оплата через Stripe · После оплаты мы свяжемся с вами в Telegram',
  },
  selPay: {
    title: 'Оплата отбора',
    sub: 'Заявка получена! Выберите формат участия и завершите оплату — после этого команда свяжется с вами в Telegram и откроет доступ к мини-курсу и демо-этапу.',
    chooseLabel: 'Выберите формат',
  },
  crypto: {
    title: 'Оплата в USDT',
    network: 'Сеть TRC20',
    walletLabel: 'Кошелёк',
    copy: 'Копировать',
    copied: 'Скопировано',
    amount: 'Сумма',
    hint: 'Переведите точную сумму на кошелёк ниже, затем нажмите кнопку — мы проверим поступление и откроем доступ.',
    paidBtn: 'Я отправил оплату',
    modalTitle: 'Подтверждение оплаты',
    modalSub: 'Укажите имя и Telegram — мы сверим транзакцию и свяжемся с вами.',
    send: 'Отправить',
    success: 'Уведомление отправлено — мы проверим оплату и свяжемся с вами',
  },
  form: {
    title: 'Оставить заявку',
    name: 'Имя', namePh: 'Как к вам обращаться',
    telegram: 'Telegram', telegramPh: '@username',
    email: 'Email', emailPh: 'you@example.com',
    phone: 'Телефон', phonePh: '+7 900 000-00-00',
    experience: 'Опыт торговли',
    expOptions: ['Нет опыта', 'До 1 года', '1–3 года', 'Более 3 лет'],
    message: 'Сообщение (необязательно)', messagePh: 'Пара слов о вашей цели',
    submit: 'Отправить заявку', sending: 'Отправляем…',
    successTitle: 'Заявка отправлена',
    successText: 'Мы свяжемся с вами в течение рабочего дня.',
    waitlistTitle: 'Заявка в лист ожидания',
    waitlistSub: 'Малая группа распродана. Оставьте контакты — мы напишем, как только появится место или откроется новый поток.',
    waitlistSuccessTitle: 'Вы в листе ожидания',
    waitlistSuccessText: 'Мы свяжемся с вами, как только освободится место.',
    error: 'Не удалось отправить. Попробуйте ещё раз.',
  },
  footer: {
    tagline: 'Профессиональная команда трейдеров. NYSE & NASDAQ.',
    links: 'Разделы',
    risk: 'Предупреждение о рисках: торговля на бирже связана с риском потери капитала. Прошлые результаты не гарантируют будущих. Контент носит образовательный характер и не является инвестиционной рекомендацией.',
    rights: '© 2026 ALEF Traders. Все права защищены.',
    tgBtn: 'Telegram поддержки',
    marketOpen: 'Рынок открыт',
    marketClosed: 'Рынок закрыт',
  },
  countdown: { label: 'До старта потока', d: 'дн', h: 'час', m: 'мин', s: 'сек' },
  dcapital,
  payment: {
    checking: 'Проверяем оплату…',
    successTitle: 'Оплата прошла успешно',
    successText: 'Доступ к мастер-классу и бонусному гайду «Как получить капитал до $1 млн» придёт через Telegram-бот. Проверьте почту и Telegram.',
    pendingText: 'Оплата обрабатывается — страница обновится автоматически.',
    successTextTraining: 'Место в потоке забронировано. Команда свяжется с вами в Telegram в течение рабочего дня и добавит в закрытый чат.',
    successTextSelection: 'Вы в отборе! Команда свяжется с вами в Telegram в течение рабочего дня и откроет доступ к мини-курсу и демо-этапу.',
    backHome: 'На главную',
    cancelTitle: 'Оплата отменена',
    cancelText: 'Ничего страшного — место ещё ваше. Завершить оплату можно в любое время, пока действует скидка.',
    retry: 'Вернуться к мастер-классу',
    retryTraining: 'Вернуться к обучению',
    retrySelection: 'Вернуться к оплате отбора',
  },
};
